function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Gt = /*#__PURE__*/function () {
  function Gt(s) {
    _classCallCheck(this, Gt);

    this.id = s, this.id = s;
  }

  _createClass(Gt, [{
    key: "Nr",
    value: function Nr() {
      var s = {};
      return null != this.browser && (s.browser = this.browser), null != this.tc && (s.browser_version = this.tc), null != this.os && (s.os_version = this.os), null != this.resolution && (s.resolution = this.resolution), null != this.language && (s.locale = this.language), null != this.timeZone && (s.time_zone = this.timeZone), null != this.userAgent && (s.user_agent = this.userAgent), s;
    }
  }]);

  return Gt;
}();

export { Gt as default };